import React from "react";

const SHIELD =
  "https://customer-assets.emergentagent.com/job_integrated-wellness-6/artifacts/amgkh1mp_logo.png";
const PROGRAMS_URL = "https://integrated-wellness-6.emergent.host/";
const MEDICAL_URL = "https://integratednycai.com/medical-care";

const EXPLORE = [
  { label: "Toolkit", href: "#toolkit" },
  { label: "How it works", href: "#how-it-works" },
  { label: "Check-ins", href: "#checkins" },
  { label: "FAQ", href: "#faq" },
  { label: "Peak State", href: "#peak-state" },
];

export default function SiteFooter() {
  return (
    <footer
      className="mt-0"
      style={{ background: "var(--iw-primary)", color: "rgba(255,255,255,0.85)" }}
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10 py-14">
        <div className="grid gap-10 md:grid-cols-[1.4fr_1fr_1fr_1.4fr]">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img src={SHIELD} alt="Integrated Wellness shield logo" width="40" height="40" loading="lazy" />
              <div>
                <div className="serif text-lg" style={{ color: "#fff", fontWeight: 700 }}>
                  Integrated Wellness
                </div>
                <div className="iw-mono uppercase" style={{ fontSize: "9px", letterSpacing: "0.22em", color: "rgba(255,255,255,0.6)" }}>
                  Nervous System Reset
                </div>
              </div>
            </div>
            <p className="text-sm leading-relaxed m-0 max-w-xs" style={{ color: "rgba(255,255,255,0.7)" }}>
              Short, guided wellness sessions — breathwork, grounding, bilateral rhythm,
              visualization, and reflection — personalized to how you feel today.
            </p>
          </div>

          <nav aria-label="Footer — explore">
            <FooterHead>Explore</FooterHead>
            <ul className="m-0 p-0 list-none space-y-2.5">
              {EXPLORE.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="footer-link" data-testid={`footer-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}>
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="Footer — ecosystem">
            <FooterHead>Ecosystem</FooterHead>
            <ul className="m-0 p-0 list-none space-y-2.5">
              <li>
                <a href={PROGRAMS_URL} target="_blank" rel="noopener noreferrer" className="footer-link" data-testid="footer-link-programs">
                  8 Wellness Programs ↗
                </a>
              </li>
              <li>
                <a href={MEDICAL_URL} target="_blank" rel="noopener noreferrer" className="footer-link" data-testid="footer-link-medical">
                  Integrated Medical Care ↗
                </a>
              </li>
              <li>
                <a href="#disclaimer" className="footer-link" data-testid="footer-link-disclaimer">
                  Wellness disclaimer
                </a>
              </li>
            </ul>
          </nav>

          <div>
            <FooterHead>Privacy &amp; Safety</FooterHead>
            <p className="text-[13px] leading-relaxed m-0" style={{ color: "rgba(255,255,255,0.7)" }}>
              Members sign in with a member ID and email over a secure session. Your reset
              history is visible only to you and the wellness team.
            </p>
            <div className="flex items-center gap-4 mt-3">
              <a href="/privacy" className="footer-link" data-testid="footer-link-privacy">
                Privacy Policy
              </a>
              <a href="/terms" className="footer-link" data-testid="footer-link-terms">
                Terms of Use
              </a>
            </div>
            <p className="text-[13px] leading-relaxed mt-3 m-0" style={{ color: "rgba(255,255,255,0.7)" }}>
              In crisis? Call or text <strong style={{ color: "#fff" }}>988</strong> (Suicide
              &amp; Crisis Lifeline) or <strong style={{ color: "#fff" }}>911</strong>.
            </p>
          </div>
        </div>

        <div
          className="mt-12 pt-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3"
          style={{ borderTop: "1px solid rgba(255,255,255,0.15)" }}
        >
          <div className="iw-mono uppercase" style={{ fontSize: "10px", letterSpacing: "0.20em", color: "rgba(255,255,255,0.55)" }}>
            © {new Date().getFullYear()} Integrated Wellness · Wellness · Non-Medical
          </div>
          <div className="iw-mono uppercase" style={{ fontSize: "10px", letterSpacing: "0.20em", color: "rgba(255,255,255,0.55)" }}>
            Does not diagnose or treat any condition
          </div>
        </div>
      </div>
    </footer>
  );
}

function FooterHead({ children }) {
  return (
    <div
      className="iw-mono uppercase mb-4"
      style={{ color: "var(--iw-accent-red)", fontSize: "10px", letterSpacing: "0.24em", fontWeight: 700 }}
    >
      {children}
    </div>
  );
}
